import { Component } from "react";
import { type match } from "react-router";

import { lazyLoadWithRetry } from "utilities/react.utilities";

import { BTAlert } from "commonComponents/btWrappers/BTAlert/BTAlert";
import { BTButtonDeprecated } from "commonComponents/btWrappers/BTButtonDeprecated/BTButtonDeprecated";
import { type IModalConfiguration } from "commonComponents/btWrappers/BTModal/BTModal";
import { BTSuspense } from "commonComponents/btWrappers/BTSuspense/BTSuspense";
import { withErrorBoundary } from "commonComponents/helpers/ErrorBoundary/ErrorBoundary";

import { type IBannerAlertProps } from "../HeaderAlerter.types";

const SubscriptionManager = lazyLoadWithRetry(
    () => import("entity/SubscriptionManager/SubscriptionManager"),
);

interface ISubscriptionBannerState {
    headerAlertModal: boolean;
}

class SubscriptionBannerInternal extends Component<IBannerAlertProps, ISubscriptionBannerState> {
    state: ISubscriptionBannerState = {
        headerAlertModal: false,
    };

    render() {
        const alert = this.props.alert;

        const alertMessage = (
            <>
                {alert.alertText}
                <BTButtonDeprecated
                    type="link"
                    data-testid="updateInfo"
                    isolated
                    onClick={this.toggleHeaderAlertModal}
                >
                    {alert.redirectText}
                </BTButtonDeprecated>
            </>
        );

        return (
            <>
                <BTAlert
                    title={alert.alertTitle}
                    message={alertMessage}
                    type="error"
                    data-testid="subscriptionError"
                    showIcon
                />
                {this.renderHeaderAlertModal()}
            </>
        );
    }

    private renderHeaderAlertModal = () => {
        const modalConfig: IModalConfiguration = {
            parentRoute: this.props.match.url,
            beforeClose: this.toggleHeaderAlertModal,
        };

        return (
            <>
                {this.state.headerAlertModal && (
                    <BTSuspense>
                        <SubscriptionManager
                            fromSettings={false}
                            fromFrozenBuilder={false}
                            modalConfig={modalConfig}
                            history={this.props.history}
                            location={this.props.location}
                            match={
                                this.props.match as match<{
                                    userId: string;
                                    jwt: string;
                                    fromSettings: string;
                                    fromFrozenBuilder: string;
                                }>
                            }
                        />
                    </BTSuspense>
                )}
            </>
        );
    };

    private toggleHeaderAlertModal = () => {
        if (this.state.headerAlertModal) {
            // todo replace with context reload once site is Single Page App (SPA)
            window.location.reload();
        }
        this.setState((prevState) => ({
            headerAlertModal: !prevState.headerAlertModal,
        }));
    };
}

const SubscriptionBanner = withErrorBoundary(SubscriptionBannerInternal)(
    "Could not load Subscription Banner",
);

export default SubscriptionBanner;
